export default {
  name: 'customer_address_number',
  component_path: 'modules/procedures/blocks/BlockInputText'
}